import { useState } from "react";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadCsv, errMsg } from "@/lib/api";

export const ExportCsvButton = ({ testid = "export-csv-button" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadCsv();
      toast.success("Transactions exported");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <button onClick={run} disabled={busy} data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-xl border border-[#212638] px-3 py-2 text-xs font-semibold text-[#94A3B8] transition-colors hover:bg-[#1C2030] hover:text-white disabled:opacity-50">
      {busy ? <Loader2 size={13} className="animate-spin" /> : <FileSpreadsheet size={13} />} Export CSV
    </button>
  );
};
